<template>
  <div class="h-96 border-t border-gray-400 overflow-hidden p-2 text-sm">
    <python-live :code="code" @skip="handleSkip"></python-live>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import pythonLive from '@/components/python-live';
import { namespace } from 'vuex-class';

const userModule = namespace('common');

enum languages {
  javascript = 'javascript',
  typescript = 'typescript',
  bpython = 'python',
  python = 'python'
}

type ValueOf<T> = T[keyof T];

@Component({
  components: {
    pythonLive
  }
})
export default class CodeBlockControl extends Vue {
  @Prop({ type: Object, default: { lang: 'python', code: '' } }) content!: Content & {
    lang: ValueOf<typeof languages>;
    code: string;
  };
  @userModule.State('loading') public globalLoading!: boolean;

  get code(): string {
    return this.content.code;
  }

  get portalView() {
    const portalSequence = this.$store.state.common.portalSequence
    return portalSequence[portalSequence.length - 1]
  }

  handleSkip() {
    if (this.globalLoading) return
    if (this.portalView) return this.$store.commit('common/popPortal');
    window.next()
    this.$emit('next')
  }
}
</script>
